import { Shark, SmartModel, Utils } from "shark-mvc";
import moment from "moment";

import NousCoreModel from "./NousCoreModel";

class ClientSolvencyRequest extends NousCoreModel {
	static STATUS_PENDING = 1;
	// static STATUS_PICKED_UP = 6;
	// static STATUS_PREPARING = 2;
	// static STATUS_READY_FOR_PICKUP = 3;
	// static STATUS_READY_FOR_SHIPPING = 4;
	// static STATUS_SHIPPED = 5;

	agentNotes = "";
	amountToEnsure = 0;
	contactGuid = "";
	ipmNotes = "";
	maxEnsurableAmount = -1;
	notifications = [];
	vatNumber = "";

	constructor (data) {
		super();
	
		if (data) {
			this.import(data);
		}
	}

	export () {
		var exportData = this.__export();
		exportData.notifications = this.exportArrayField("notifications");
		return exportData;
	}
	
	validate () {
		const errors = [];
		this.__errors = {};
		
		
		if (this.vatNumber === "") {
			errors.push("Devi inserire la Partita IVA.");
			this.__errors["vatNumber"] = true;
		}
		if (this.amountToEnsure <= 0) {
			errors.push("Devi inserire l'importo da assicurare.");
			this.__errors["amountToEnsure"] = true;
		}

		this.__isValid = this.__errorsCount === 0;

		return errors;
	}
}

Shark.registerModel("ClientSolvencyRequest", ClientSolvencyRequest);

export default ClientSolvencyRequest;